/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */


export interface CompoTree {
  id: number;
  header: string;
  disabled?: boolean;
}



/**
 * Recursively transforms nested object into flat list
 * for using in simple select input
 * was: [{id:1,
 *       name:'SomeParent'
 *       children: [
 *        {id:2, name: 'SomeChild'},
 *        {...}
 *        ]
 *       },{...}]
 * became: [
 *          {id:1, name: 'Root / SomeParent', disabled: true},
 *          {id:2, name: 'Root / SomeParent / SomeChild' disabled: false},
 *          {...}
 *         ]
 *
 * @param tree nestedTree
 * @param flatTree flatTree
 * @param prefix separator for branches (i.e. First lvl / Second lvl / Third lvl - the slash is the separator)
 * @param field Name of field with nesting objects
 */
export function flatTreeTransformDisable<T extends CompoTree>(tree: T[], flatTree: CompoTree[], prefix = '', field: string): CompoTree[]
{

  tree.forEach(item => {
    const name = prefix + ' / ' + item.header;
    // flatTree.push({id: item.id, header: name, disabled: true});
    if (item[field].length) {
      // Recursive call
      flatTree.push({id: item.id, header: name, disabled: true});
      return flatTreeTransformDisable(item[field], flatTree, name, field);
    }else{
      flatTree.push({id: item.id, header: name, disabled: false});
    }
  });

  return flatTree;
}


/**
 * Recursively transforms nested object into flat list
 * for using in simple select input
 * was: [{id:1,
 *       name:'SomeParent'
 *       children: [
 *        {id:2, name: 'SomeChild'},
 *        {...}
 *        ]
 *       },{...}]
 * became: [
 *          {id:1, name: 'Root / SomeParent'},
 *          {id:2, name: 'Root / SomeParent / SomeChild'},
 *          {...}
 *         ]
 *
 * @param tree nestedTree
 * @param flatTree flatTree
 * @param prefix separator for branches (i.e. First lvl / Second lvl / Third lvl - the slash is the separator)
 * @param field Name of field with nesting objects
 */
export function flatTreeTransform<T extends CompoTree>(tree: T[], flatTree: CompoTree[], prefix = '', field: string): CompoTree[]
{

  tree.forEach(item => {

    const name = prefix + ' / ' + item.header;
    flatTree.push({id: item.id, header: name});
    if (item[field].length) {
      // Recursive call
      return flatTreeTransform(item[field], flatTree, name, field);
    }
  });

  return flatTree;
}
